module.exports = __webpack_public_path__ + "static/img/banner.b4cd4e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/supplyDetail/banner.png
// module id = VPqr
// module chunks = 44